"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var rule_constants_1 = require("./rule-constants");
var element_condition_1 = require("./element-condition");
exports.defaultValues = __assign({}, element_condition_1.defaultValues, { type: rule_constants_1.conditionTypes.equal, value: undefined });
/** Factory that generates Immutable [[IElementValueCondition]] */
exports.ElementValueConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IElementValueCondition]] */
var ImmutableElementValueCondition = /** @class */ (function (_super) {
    __extends(ImmutableElementValueCondition, _super);
    function ImmutableElementValueCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableElementValueCondition;
}(exports.ElementValueConditionRecord));
exports.ImmutableElementValueCondition = ImmutableElementValueCondition;
//# sourceMappingURL=element-value-condition.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/element-value-condition.js
// module id = 1113
// module chunks = 0